<template>
	<div>
		<ed-alert title="Atenção" 
			type="warning" description="Aqui você pode inserir uma nova categoria para classificar uma coluna se houver necessidade." 
			class="mb-2"
		/>

		<!--EDITAR VERSÃO-->
		<CategoriaEdit :tabela="tabela" :parent="this" />

		<!--LISTAR VERSAO-->

		<ed-table
			registerName="Inserir Nova Categoria"
			:onRegister="(this.validarPermissao(571) ? onRegister: null)"
			:onEdit="onEdit"
			:onDelete="onDelete"
			:onSearch="getTabelaDinamicaCategoria"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="loadingTable"
			:loadingEditAll="loadingEditAll"
			:pagination="pagination"
			:response="response"
		/>
	</div>
</template>

<script>

	import EdTable from 'common/table'
	import Rest from 'common/rest'
	import Fct from 'common/fct'
	import EdAlert from 'common/alert'
	import CategoriaEdit from './editar'

  	export default {
  		name:"empresa",
  		components: {EdTable,EdAlert,CategoriaEdit},
		mixins:[Rest],
		props:{
            tabela:{
                type: Object,
                default: null
            },
		},
		watch:{
			'tabela.id'(){
				this.getTabelaDinamicaCategoria();
			}
		},
  		data () {
		   	return {
		   		formData:{
		   			id:0,
		   			nome:null,
		   			ativo:1,
		   		},
				pagination:{},
				response:{},
		   		tableHead:[
					{
		                key: 'id',
						sortable: true,
						width:'60px',
						label: 'Cód',
		            },
		            {
		                key: 'nome',
						sortable: true,
						label: 'Nome',
					},
					 {
		                key: 'ativo',
						sortable: true,
						label: 'Ativo',
					},
					{
		                key: 'updated_at',
						sortable: true,
						show_user:true,
						label: 'Atualização',
					},
		   		],
		   		tableData:[],
		   		loadingTable:true,
		   		loadingEditAll:false,
		   		showFormVersao:false,
		   		lstTipoPagamento:[]

			}
		},

		created(){
		},

		mounted: function() {
			this.getTabelaDinamicaCategoria();
		},

		methods: {

			onRegister: function(){

				this.formData = {
					id:0,
					nome:null,
					usuario:null,
					updated_at:null,
					ativo:1
				};
				this.showFormVersao = !this.showFormVersao;
			},

			onEdit: function(data){
				
				this.formData = {
					id:data.id,
					nome:data.nome,
					usuario:data.usuario,
					updated_at:data.updated_at,
					ativo:data.ativo
				};
				this.showFormVersao = !this.showFormVersao;
			},

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    type: 'warning'

                }).then(() => {

                    self.loadingEditAll = true;

                    this.post('/ltcat/tabela-dinamica/categoria/'+this.tabela.id+'/deletar',{ids:data}).then((result)=>{
                        result = result[0];

                        self.loadingEditAll = false;

                        if(result.status == 200){
                            self.getTabelaDinamicaCategoria();
                            self.edMsg('Registo excluido com sucesso');
                        }
                    });

                });
			},

			getTabelaDinamicaCategoria: function(_search,_page,_pagination){

				this.loadingTable = true;
				this.response = {};

				this.get('/ltcat/tabela-dinamica/categoria/'+this.tabela.id,{search:_search,page:_page,pagination:_pagination}).then((result)=>{

					result = result[0];
					this.response = result;
					this.loadingTable = false;

		            if(result.status == 200){

		             	var
		             		data = result.data.data,
		             		tableData = [],
		             		self = this,
		             		pagination = result.data

		             	for (var i = 0; i < data.length; i++) {

		             		var item = {
								'id': data[i].id,
								'nome': data[i].nome,
								'ativo': (data[i].ativo == 1 ? 'Sim' : 'Não'),
								'updated_at': this.toDate(data[i].updated_at),
		             			_data:data[i],
		             			options:{
									style:'color:'+(data[i].ativo == 0 ? 'red' : ''),
									disable_delete:!this.validarPermissao(571),
									disable_edit:!this.validarPermissao(571),
								},
		             			buttons:[]
		             		};

		             		tableData.push(item);
		            	}

		             	this.pagination = pagination;
		             	this.tableData = tableData;
		             }
	            });
			},

		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?2126f88a